import React from 'react'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import styles from './SidebarCollapseToggle.module.css'

const STORAGE_KEY = 'isCollapsedSidebar'

const SidebarCollapseToggle = ({ isCollapsed, onChange }) => {
  const handleToggle = () => {
    const next = !isCollapsed
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    if (onChange) onChange(next)
  }

  return (
    <div className={styles.toggleWrapper}>
      <button
        className={styles.toggleBtn}
        data-collapsed={isCollapsed}
        onClick={handleToggle}
        title={isCollapsed ? 'Mở rộng sidebar' : 'Thu gọn sidebar'}>
        {isCollapsed ? (
          <MenuUnfoldOutlined className={styles.toggleIcon} />
        ) : (
          <MenuFoldOutlined className={styles.toggleIcon} />
        )}
        {!isCollapsed && (
          <span className={styles.toggleLabel}>Thu gọn sidebar</span>
        )}
      </button>
    </div>
  )
}

export default SidebarCollapseToggle
